export const iconFontAwesomeMapsSquareH = (
	<i className="fa-solid fa-square-h"></i>
);
